import Splide, { Options } from '@splidejs/splide';

export function accessoriesPairsSliders(): void {
    const sliderPairs = document.querySelectorAll<HTMLElement>('.splide-accessories-pair');

    if (sliderPairs.length === 0) return;

    sliderPairs.forEach((pair) => {
        const imageEl = pair.querySelector<HTMLElement>('.splide-image');
        const thumbnailEl = pair.querySelector<HTMLElement>('.splide-thumbnail');
        const textEl = pair.querySelector<HTMLElement>('.splide-text');

        if (!imageEl || !thumbnailEl || !textEl) return;

        // Create Splide instances
        const imageOptions: Options = {
            type: 'fade',
            rewind: true,
            pagination: false,
            arrows: true,
            arrowPath: 'M 25.912216,34.175412 24.328359,32.647051 35.77786,21.197549 H 0 V 18.977707 H 35.820481 L 24.383855,7.5283613 25.912216,6 40,20.087628 Z',
        };

        const thumbnailOptions: Options = {
            rewind: true,
            fixedWidth: 100,
            fixedHeight: 80,
            isNavigation: true,
            gap: 10,
            focus: 'center',
            pagination: false,
            cover: true,
            arrowPath: 'M 25.912216,34.175412 24.328359,32.647051 35.77786,21.197549 H 0 V 18.977707 H 35.820481 L 24.383855,7.5283613 25.912216,6 40,20.087628 Z',
            dragMinThreshold: {
                mouse: 4,
                touch: 10,
            },
            breakpoints: {
                640: {
                    fixedWidth: 66,
                    fixedHeight: 38,
                },
            },
        };

        const textOptions: Options = {
            type: 'fade',
            rewind: true,
            pagination: false,
            arrows: true,
            arrowPath: 'M 25.912216,34.175412 24.328359,32.647051 35.77786,21.197549 H 0 V 18.977707 H 35.820481 L 24.383855,7.5283613 25.912216,6 40,20.087628 Z',
        };

        const images = new Splide(imageEl, imageOptions);
        const thumbnails = new Splide(thumbnailEl, thumbnailOptions);
        const text = new Splide(textEl, textOptions);

        // Sync all three sliders - thumbnails controls both images and text
        images.sync(thumbnails);
        text.sync(thumbnails);

        // Mount them     
        images.mount();
        text.mount();
        thumbnails.mount();
    });
}
